import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../auth-context/auth-context';
import routeConfig from '../../config/routeConfig';
import { useSidebar } from '../../provider/sidebar/sidebar-context';
import img from '../../images/logo_cybersign.svg';
import styles from './styles.module.css';

const CyberSidenav: React.FC = () => {
	const location = useLocation();

	const { isAuthenticated } = useContext(AuthContext);

	const { isHidden, hideSidebar } = useSidebar();

	const closeSidenav = () => {
		hideSidebar();
	};

	if (location.pathname.match(routeConfig.requestSignature)) {
		return null;
	}

	return (
		<div
			className={`${styles['cyber-sidenav']} ${isHidden ? '' : styles.visible}`}
			onClick={closeSidenav}
			id="cyber-sidenav"
		>
			<Link to={isAuthenticated ? routeConfig.dashboard : '/'}>
				<img src={img} className={styles.logo} alt="" />
			</Link>
			<div className={styles['cyber-nav']}>
				{isAuthenticated ? (
					<>
						<Link
							className={styles.link}
							to={routeConfig.dashboard}
						>
							Dashboard
						</Link>
						<Link
							className={styles.link}
							to={routeConfig.mySignatures}
						>
							Mis firmas
						</Link>
						<Link
							className={styles.link}
							to={routeConfig.customManuscript}
						>
							Mi Rúbrica
						</Link>
						<Link className={styles.link} to={routeConfig.pinSetup}>
							Configurar PIN
						</Link>
						<Link
							className={styles.link}
							to={routeConfig.myDocuments}
						>
							Mis Documentos
						</Link>
						<Link
							className={styles.link}
							to={routeConfig.mySignatreRequests}
						>
							Solicitudes de firma
						</Link>
						<hr className={styles.divider} />
					</>
				) : (
					<></>
				)}
				<a
					className={styles.link}
					href="https://cybersign.gt/validar-documento"
				>
					Validar Documento
				</a>
				<Link
					className={styles.link}
					to={routeConfig.consultCertificate}
				>
					Consultar Certificado
				</Link>
				<Link className={styles.link} to={routeConfig.products}>
					Productos y Servicios
				</Link>
				<Link className={styles.link} to={routeConfig.requirements}>
					Requisitos
				</Link>
				<Link className={styles.link} to={routeConfig.legal}>
					Marco Legal
				</Link>
				<Link className={styles.link} to={routeConfig.policies}>
					Políticas y procedimientos
				</Link>
				<Link
					className={styles.link}
					to={routeConfig.certificateAndCrl}
				>
					Certificados y CRL
				</Link>
				{/* <Link className={styles.link} to={routeConfig.contact}>Contacto</Link> */}
			</div>
		</div>
	);
};

export default CyberSidenav;
